import axios, { AxiosInstance } from 'axios'
import store from '@/store/store'
import _ from 'lodash'

class HttpRequestWithToken {
  private service: AxiosInstance

  constructor() {
    const service = axios.create()
    service.interceptors.response.use(this.handleSuccess, this.handleError)
    this.service = service
  }

  public async get(path: any, options: {[key: string]: any}, callback: any = (response: any) => response) {
    let option = {}
    option = {
      ...options,
      headers: {
        ...options.headers,
        token: store.getters['userprofile/getLine'].token,
      },
    }
    return this.service
      .get(path, option)
      .then(
        async (response: any) => await callback(response ? response.data : null, response && response.status),
      )
      .catch((error) => {
        // store.dispatch('components/updateSnackbar', {
        //   txt:
        //     error.response.data && error.response.data.message
        //       ? error.response.data.message
        //       : 'Something went wrong.',
        //   type: 'error',
        // })
        throw error
      })
  }

  public async getByLevel(
    host: string, path: string, options: {[key: string]: any},
    callback: any = (response: any) => response,
  ) {
    const level = store.getters['components/level']
    const centerId = level.mode === 'center' ? level.id : undefined
    const headers = {
      ...options.headers,
      centerId,
      token: store.getters['userprofile/getLine'].token,
    }
    const option = {
      ...options,
      headers: _.pickBy(headers, _.identity),
    }
    return this.service
      .get(`${host}/${level.mode}/${path}`, option)
      .then(
        async (response: any) => await callback(response ? response.data : null, response && response.status),
      )
      .catch((error) => {
        // store.dispatch('components/updateSnackbar', {
        //   txt:
        //     error.response.data && error.response.data.message
        //       ? error.response.data.message
        //       : 'Something went wrong.',
        //   type: 'error',
        // })
        throw error
      })
  }

  public async patch(path: any, payload: any, callback: any = (response: any) => response) {
    return this.service.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload,
      headers: {
        token: store.getters['userprofile/getLine'].token,
      },
    })
      .then(async (response: any) => await callback(response && response.data, response && response.status))
      .catch((error) => {
        store.dispatch('components/updateSnackbar', {
          txt:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Something went wrong.',
          type: 'error',
        })
        throw error
      })
  }

  public async patchByLevel(host: string, path: string, payload: any, callback: any = (response: any) => response) {
    const level = store.getters['components/level']
    const headers = {
      centerId: level.mode === 'center' ? level.id : undefined,
      token: store.getters['userprofile/getLine'].token,
    }
    return this.service.request({
      method: 'PATCH',
      url: `${host}/${level.mode}/${path}`,
      responseType: 'json',
      data: payload,
      headers: _.pickBy(headers, _.identity),
    })
      .then(async (response: any) => await callback(response && response.data, response && response.status))
      .catch((error) => {
        store.dispatch('components/updateSnackbar', {
          txt:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Something went wrong.',
          type: 'error',
        })
        throw error
      })
  }

  public async post(path: any, payload: any, callback: any = (response: any) => response) {
    return this.service.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload,
      headers: {
        token: store.getters['userprofile/getLine'].token,
      },
    }).then(async (response: any) => await callback(response && response.data, response && response.status))
      .catch((error) => {
        store.dispatch('components/updateSnackbar', {
          txt:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Something went wrong.',
          type: 'error',
        })
        throw error
      })
  }
  public async postByLevel(host: string, path: string, payload: any, callback: any = (response: any) => response) {
    const level = store.getters['components/level']
    const headers = {
      centerId: level.mode === 'center' ? level.id : undefined,
      token: store.getters['userprofile/getLine'].token,
    }
    return this.service.request({
      method: 'POST',
      url: `${host}/${level.mode}/${path}`,
      responseType: 'json',
      data: payload,
      headers: _.pickBy(headers, _.identity),
    }).then(async (response: any) => await callback(response && response.data, response && response.status))
      .catch((error) => {
        store.dispatch('components/updateSnackbar', {
          txt:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Something went wrong.',
          type: 'error',
        })
        throw error
      })
  }

  public async put(path: any, payload: any, callback: any = (response: any) => response) {
    return this.service.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: payload,
      headers: {
        token: store.getters['userprofile/getLine'].token,
      },
    })
      .then(async (response: any) => await callback(response && response.data, response && response.status))
      .catch((error) => {
        store.dispatch('components/updateSnackbar', {
          txt:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Something went wrong.',
          type: 'error',
        })
        throw error
      })
  }

  public async putByLevel(host: string, path: string, payload: any, callback: any = (response: any) => response) {
    const level = store.getters['components/level']
    const headers = {
      centerId: level.mode === 'center' ? level.id : undefined,
      token: store.getters['userprofile/getLine'].token,
    }
    return this.service.request({
      method: 'PUT',
      url: `${host}/${level.mode}/${path}`,
      responseType: 'json',
      data: payload,
      headers: _.pickBy(headers, _.identity),
    })
    .then(async (response: any) => await callback(response && response.data, response && response.status))
    .catch((error) => {
      store.dispatch('components/updateSnackbar', {
        txt:
          error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Something went wrong.',
        type: 'error',
      })
      throw error
    })
  }

  public async delete(path: any, params?: any, callback: any = (response: any) => response) {
    return this.service.request({
      method: 'DELETE',
      url: path,
      responseType: 'json',
      params,
      headers: {
        token: store.getters['userprofile/getLine'].token,
      },
    })
      .then(async (response: any) => await callback(response && response.data, response && response.status))
      .catch((error) => {
        store.dispatch('components/updateSnackbar', {
          txt:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Something went wrong.',
          type: 'error',
        })
        throw error
      })
  }
  public async deleteByLevel(host: string, path: string, params?: any, callback: any = (response: any) => response) {
    const level = store.getters['components/level']
    const headers = {
      centerId: level.mode === 'center' ? level.id : undefined,
      token: store.getters['userprofile/getLine'].token,
    }
    return this.service.request({
      method: 'DELETE',
      url: `${host}/${level.mode}/${path}`,
      responseType: 'json',
      params,
      headers: _.pickBy(headers, _.identity),
    })
      .then(async (response: any) => await callback(response && response.data, response && response.status))
      .catch((error) => {
        store.dispatch('components/updateSnackbar', {
          txt:
            error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Something went wrong.',
          type: 'error',
        })
        throw error
      })
  }

  private redirectTo = (document: any, path: string) => {
    document.location = path
  }

  private handleSuccess(response: any) {
    return response || {}
  }

  private handleError = (error: any) => {
    switch (error.response.status) {
      case 401:
        window.localStorage.clear()
        this.setTmpPath()
        window.location.reload()
        break
      case 404:
        if (error.request.responseURL.includes('/authentication') && window.location.pathname !== '/signup') {
          this.setTmpPath()
          window.location.href = '/signup'
        }
        // this.redirectTo(document, '/404')
        break
      default:
        throw error
    }
    return Promise.reject(error)
  }

  private setTmpPath() {
    if (window.location.pathname !== '/signup') {
      if (!['/redirect', '/'].includes(window.location.pathname)) {
        localStorage.setItem('tmpPath', window.location.pathname + window.location.search)
      }
    }
  }
}

export default new HttpRequestWithToken()
